import type { LoadStatus } from "@src/types/api";
import type { LoadApplication } from "@src/load-agent/LoadApplication";
import type { ReplyAllDraftRequest } from "@src/load-agent/types/emailDraft";
import { openOutlookReplyAllWithAttachments } from "@src/load-agent/office/outlookReplyDraft";

export type PostBookWorkflowSideEffects = {
  replyAllWithAttachments: (request: ReplyAllDraftRequest) => Promise<void>;
  updateLoadStatus: (params: {
    mode: "LTL" | "FTL";
    shipmentId: string;
    internetMessageId: string;
    loadStatus: LoadStatus;
    actorEmail?: string;
    interactingUser?: string;
  }) => Promise<void>;
};
export function createDefaultPostBookWorkflowSideEffects(
  loadApp: Pick<LoadApplication, "updateLTLLoadStatus" | "updateFTLLoadStatus">
): PostBookWorkflowSideEffects {
  return {
    replyAllWithAttachments: openOutlookReplyAllWithAttachments,
    updateLoadStatus: ({
      mode,
      shipmentId,
      internetMessageId,
      loadStatus,
      actorEmail,
      interactingUser,
    }) =>
      mode === "LTL"
        ? loadApp.updateLTLLoadStatus({
            shipmentId,
            internetMessageId,
            loadStatus,
            actorEmail,
            interactingUser,
          })
        : loadApp.updateFTLLoadStatus({
            shipmentId,
            internetMessageId,
            loadStatus,
            actorEmail,
            interactingUser,
          }),
  };
}
